import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AvatarIcon from "assets/icons/avatar.svg?react";
import EmailIcon from "assets/icons/email.svg?react";

import styles from "./StaffDisplay.module.css";
import Modal from "components/Modal";

const StaffDisplay = ({
    name,
    role,
    email,
    bio,
    avatar,
    canvasUserId,
    bookMeeting,
    fullWidth,
    underline,
}) => {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <div
                className={`${styles.staffDisplay} ${fullWidth ? styles.fullWidth : ""} ${underline ? styles.underline : ""}`}
                data-testid={`staff-display-${name.toLowerCase().replace(/\s/g, "-")}`}
            >
                <div
                    className={styles.staffDisplayAvatar}
                    onClick={() => setIsModalOpen(true)}
                >
                    {avatar ? (
                        <img
                            src={avatar}
                            alt={`${name}'s avatar`}
                            className={styles.staffDisplayAvatarImage}
                        />
                    ) : (
                        <AvatarIcon />
                    )}
                </div>
                <div className={styles.staffDisplayInfo}>
                    <div className={styles.staffDisplayTitle}>
                        <p>{name} | </p>
                        <p> {role}</p>
                    </div>
                    <div className={styles.staffDisplayEmail}>
                        <EmailIcon /> <p>{email}</p>
                    </div>
                    {bookMeeting && (
                        <button
                            className={styles.staffDisplayButton}
                            onClick={() =>
                                navigate(`/bookameeting/${canvasUserId}`)
                            }
                        >
                            BOOK A MEETING
                        </button>
                    )}
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <StaffDisplay
                    name={name}
                    role={role}
                    email={email}
                    avatar={avatar}
                    canvasUserId={canvasUserId}
                    fullWidth
                />
                <p className={styles.staffDisplayModalText}>{bio}</p>
                {bookMeeting && (
                    <button
                        className={styles.staffDisplayModalButton}
                        onClick={() =>
                            navigate(`/bookameeting/${canvasUserId}`)
                        }
                    >
                        BOOK A MEETING
                    </button>
                )}
            </Modal>
        </>
    );
};

export default StaffDisplay;
